export class UrpKbRequestDto {
  urpTrTagId: number;
  datum: string;
  prId: number;
  basId: number;
  lmifId: number;
  regieId: number;
  kbId: number;
  codeIds: number[];
  lieferscheinId: number;
}
